var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import ToolBar from '../../parts/ToolBar.vue';
import PinDialog from '../../parts/PinDialog.vue';
import MessageModule from '../../mixins/MessageModule';
import TransactionModule from '../../mixins/TransactionModule';
import { TransactionWrapper } from "../../../lib/transactionWrapper";
import { PinCodeHelper, WalletsHelper } from "../../../lib/storage";
import { Account, Address } from "nem-library";
import { getAccountHttp, getMosaicHttp } from "../../../lib/nisUtils";
import { getDivided } from "../../../lib/numberUtils";
import { createMosaicTransferableFrom } from "../../../lib/mosaicUtils";
const mosaicsType = {};
export default Vue.extend({
    mixins: [MessageModule, TransactionModule],
    components: { ToolBar, PinDialog },
    name: "TransactionDetail",
    data() {
        return {
            decryptedMessage: '',
            showPinDialog: false,
            decrypting: false,
            fetchingMosaicDefinitions: false,
            mosaics: Object.assign({}, mosaicsType)
        };
    },
    computed: {
        transaction() {
            return this.$store.state.transaction;
        }
    },
    methods: {
        tryDecryptMessage() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.transaction.message.isEncrypted()) {
                    return;
                }
                const wallet = yield WalletsHelper.getActive();
                if (wallet == null) {
                    return;
                }
                if (!(yield PinCodeHelper.hasSavedCode())) {
                    const rawSecret = wallet.decryptSecret(PinCodeHelper.defaultPin);
                    if (rawSecret) {
                        this.decryptMessage(rawSecret);
                    }
                }
                else {
                    this.showPinDialog = true;
                }
            });
        },
        decryptMessage(secret) {
            const account = Account.createWithPrivateKey(secret);
            const message = this.transaction.message;
            if (this.transaction.isReception) {
                const senderPublic = this.transaction.senderPublic;
                if (senderPublic == null) {
                    this.showError(this.$t('transaction.failed_to_decrypt').toString());
                    return;
                }
                this.decryptedMessage = account.decryptMessage(message, senderPublic).payload;
            }
            else {
                // Get receiver public key
                const accountHttp = getAccountHttp();
                let address;
                try {
                    address = new Address(this.transaction.receiverAddress);
                }
                catch (_a) {
                    this.showError(this.$t('transaction.failed_to_decrypt').toString());
                    return;
                }
                this.decrypting = true;
                accountHttp.getFromAddress(address).subscribe(accountInfoWithMetaData => {
                    if (accountInfoWithMetaData.publicAccount.hasPublicKey()) {
                        this.decryptedMessage = account.decryptMessage(message, accountInfoWithMetaData.publicAccount).payload;
                    }
                    else {
                        this.showError(this.$t('transaction.failed_to_decrypt').toString());
                    }
                    this.decrypting = false;
                }, error => {
                    this.showError(this.$t('transaction.failed_to_decrypt').toString());
                    this.decrypting = false;
                });
            }
        },
        onPassed(pin) {
            return __awaiter(this, void 0, void 0, function* () {
                const wallet = yield WalletsHelper.getActive();
                if (wallet == null) {
                    return;
                }
                const secret = yield WalletsHelper.decryptKey(wallet.id, pin);
                if (secret == null) {
                    this.showError(this.$t('transaction.failed_to_decrypt').toString());
                    return;
                }
                this.decryptMessage(secret);
            });
        }
    },
    mounted() {
        // Fail safe
        if (this.transaction === null || !(this.transaction instanceof TransactionWrapper)) {
            this.$router.replace('/transaction/list');
        }
        // fetch mosaic
        this.fetchingMosaicDefinitions = true;
        const mosaicHttp = getMosaicHttp();
        for (let mosaic of this.transaction.mosaics) {
            if (mosaic.mosaicId.name === "xem" && mosaic.mosaicId.namespaceId === "nem") {
                this.mosaics[mosaic.mosaicId.description()] = getDivided(mosaic.quantity, 6).toNumber();
            }
            else {
                mosaicHttp.getMosaicDefinition(mosaic.mosaicId).subscribe(mosaicDefinition => {
                    const mosaicTransferable = createMosaicTransferableFrom(mosaicDefinition, mosaic.quantity);
                    this.mosaics[mosaicTransferable.mosaicId.description()] = mosaicTransferable.amount;
                    if (Object.keys(this.mosaics).length >= this.transaction.mosaics.length) {
                        this.fetchingMosaicDefinitions = false;
                    }
                }, error => {
                });
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/transaction/TransactionDetail.vue
// module id = 609
// module chunks = 1